/**
 * meta.js
 * Written by: Alex Kasemir
 */

import notificationActions from 'store/notification/actions';

const initialState = {
  loaded: false,
};
/**
 * Description of the meta reducer
 */
const meta = (state = initialState, action) => {
  switch (action.type) {
    case notificationActions.GET_NOTIFICATIONS_SUCCESS:
      return {
        loaded: true,
      };
    default:
      return state;
  }
};

export default meta;
